import architectProfessional from './../images/solutionsArchitectProffesional.png';
import architectAssociate from './../images/solutionsArchitectAssociate.png';
import developerCertification from './../images/developerCertification.png';
import securityCertification from './../images/securityCertification.png';
import databaseCertification from './../images/databaseCertification.png';
import devOpsProfessional from './../images/devOpsCertification.png';
import machineLearningSpeciality from "./../images/machineLearningCertification.png";

const sectionStyle = {
  maxWidth: "1100px",
  margin: "0 auto",
  padding: "60px 20px"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: "20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "20px",
  background: "#fff",
  transition: "all 0.2s ease"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 10px 25px rgba(0,0,0,0.08)"
    : "none";
  e.currentTarget.style.transform = enter
    ? "translateY(-2px)"
    : "translateY(0)";
};

const AboutWho = () => {
  const certifications = [
    { img: architectProfessional, title: "AWS Solutions Architect – Professional" },
    { img: devOpsProfessional, title: "AWS DevOps Engineer – Professional" },
    { img: "/images/awsAiPractitionerBadge.png", title: "AWS Certified AI Practitioner" },
    { img: "/images/awsDataEngineerBadge.png", title: "AWS Certified Data Engineer – Associate" },
    { img: machineLearningSpeciality, title: "AWS Certified Machine Learning – Specialty" },
    { img: securityCertification, title: "AWS Certified Security – Specialty" },
    { img: databaseCertification, title: "AWS Certified Database – Specialty" },
    { img: developerCertification, title: "AWS Certified Developer – Associate" },
    { img: architectAssociate, title: "AWS Solutions Architect – Associate" }
  ];

  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "42px", marginBottom: "20px" }}>
          AWS Certifications & Expertise
        </h1>

        <p style={{ fontSize: "20px", color: "#555", maxWidth: "700px" }}>
          I hold multiple AWS certifications across architecture, development, security,
          data, and machine learning. These certifications validate real-world expertise
          in designing and building production-grade cloud systems.
        </p>
      </div>


      {/* WHAT THIS MEANS */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "30px" }}>
          What This Means for Your Project
        </h2>

        <div style={gridStyle}>
          {[
            "Design of scalable, production-grade AWS architectures",
            "Security-first approach (IAM, encryption, compliance)",
            "Strong DevOps and CI/CD automation expertise",
            "Deep knowledge of databases and data systems",
            "Practical experience with AI/ML services",
            "End-to-end delivery: architecture → implementation → optimization"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* CERTIFICATIONS GRID */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "30px" }}>Certifications</h2>

        <div style={gridStyle}>
          {certifications.map((cert, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              <img
                src={cert.img}
                alt={cert.title}
                style={{ width: "100%", marginBottom: "10px" }}
              />

              <div style={{ fontSize: "14px", textAlign: "center" }}>
                {cert.title}
              </div>
            </div>
          ))}
        </div>
      </div>


      {/* EXPERIENCE CONTEXT */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "20px" }}>Beyond Certifications</h2>

        <p style={{ color: "#555", maxWidth: "700px" }}>
          Certifications are supported by over 20 years of experience in software engineering,
          including enterprise systems, distributed architectures, and cloud-native platforms.
          I have worked on large-scale solutions in finance and IoT domains, focusing on
          scalability, performance, and reliability in production environments.
        </p>
      </div>

    </div>
  );
};

export default AboutWho;